export default {
  methods: {
    readableFileName (value) {
      if (value) {
        return decodeURI(value.split('/').pop())
      }
    }
  }
}
